import { NOTIFICATION_TYPES, Notifications } from "@/models/notification";
import { useAuthStore } from "@/pinia/useAuthStore";
import { EventSourcePolyfill } from "event-source-polyfill";
import { storeToRefs } from "pinia";
import { inject } from "vue";
import { MESSAGE_INBOUND_TYPE } from "@/models/message";
import { useMessagesStore } from "@/pinia/useMessagesStore";
import { noop } from "underscore";
import { ROUTE_NAME } from "@/router/routes.constants";
import { useRouter } from "vue-router";

export default () => {
  let lastEvent: any = "";
  const url = "/api/event-notification/subscribe";
  const emitter: any = inject("emitter");
  const { getAccessToken } = storeToRefs(useAuthStore());
  const router = useRouter();
  const { setDetails } = useMessagesStore();
  let reconnectAttempts = 0;
  const openSubscriptions = () => {
    let eventSource = new EventSourcePolyfill(url, {
      headers: {
        Authorization: `Bearer ${getAccessToken.value}`,
        lastEventId: lastEvent,
      },
      heartbeatTimeout: 3 * 60 * 1000,
    });

    eventSource.onopen = (event) => console.log("onopen: ", event);

    eventSource.onmessage = (event: any) => {
      lastEvent = event.lastEventId;
      event.data = JSON.parse(event.data);
      const notification = getNotificationSettings(event?.data);
      if (!notification.show) {
        return;
      }
      emitter.emit("show-notification", notification);
    };

    eventSource.onerror = (event: any) => {
      console.log("onError: ", event);
      eventSource.close();

      reconnectAttempts++;
      if (reconnectAttempts <= 5) {
        const delay = Math.min(30000, 1000 * Math.pow(2, reconnectAttempts));
        setTimeout(() => {
          openSubscriptions();
        }, delay);
      }
    };
  };

  const getNotificationSettings = (event: any) => {
    const notificationSettings: Notifications = {
      show: true,
      message: event?.data?.messagePreview,
      type: NOTIFICATION_TYPES.INFO,
      title: event?.data?.senderAddress ?? "Unknown",
      avatarLiteralName: event?.data?.senderAddress ?? "Unknown",
      data: event?.data,
    };

    switch (event?.type) {
      case MESSAGE_INBOUND_TYPE.NEW_INBOUND_MESSAGE:
        if (event?.data?.senderContactName) {
          notificationSettings.avatarLiteralName =
            event?.data?.senderContactName;
        }
        notificationSettings.title = notificationSettings.avatarLiteralName;
        break;
      case MESSAGE_INBOUND_TYPE.SOS_ALERT:
      case MESSAGE_INBOUND_TYPE.SOS_ALERT_UPDATE:
        notificationSettings.type = NOTIFICATION_TYPES.ERROR;
        break;
      default:
        notificationSettings.show = false;
        notificationSettings.type = NOTIFICATION_TYPES.ERROR;
        break;
    }

    return notificationSettings;
  };

  emitter.on("notification-clicked", (notification: Notifications) => {
    if (notification.type == NOTIFICATION_TYPES.INFO) {
      const senderAddress = notification.data?.senderAddress;
      const details = {
        ...(notification.data?.senderContactId && {
          senderContactId: notification.data?.senderContactId,
        }),
        senderAddress: senderAddress,
      };
      setDetails(details);
      router
        .push({
          name: ROUTE_NAME.COMPOSE,
        })
        .then(noop)
        .catch(noop);
    } else if (notification.type == NOTIFICATION_TYPES.ERROR) {
      router
        .push({
          name: ROUTE_NAME.MESSAGES,
        })
        .then(noop)
        .catch(noop);
    }
  });

  return {
    openSubscriptions,
  };
};
